import * as React from 'react';
export const IcEntertainmentPlay = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.13 3H6a3 3 0 00-3 3v1h3.46l2.67-4zm3.33 4l2.67-4h-3.59L8.87 7h3.59zm7.66-3.12A3 3 0 0018 3h-.46l-2.67 4H21V6a3 3 0 00-.88-2.12zM3 18a3 3 0 003 3h12a3 3 0 003-3V9H3v9zm7-5a1 1 0 01.14-.51 1.06 1.06 0 01.39-.37A1 1 0 0111 12a1 1 0 01.49.16l3 2a.92.92 0 01.32.36 1 1 0 010 .94.92.92 0 01-.32.36l-3 2A1 1 0 0111 18a.92.92 0 01-.51-.12 1 1 0 01-.37-.36A.89.89 0 0110 17v-4z'
      fill='currentColor'
    />
  </svg>
);
